/**
 * Created by toomasp on 28.07.2015.
 */

import { signatureService } from './signature.service';
import { LoaderContext } from './loader-context.service';
import { MessengerProxyService } from 'core/common/services/messenger-proxy.service';

export const coreServiceModule = angular.module('eservice.core.services', [])
    .value('signatureService', signatureService)
    .service('loaderContext', LoaderContext)
    .service('messengerProxyService', MessengerProxyService);



// WEBPACK FOOTER //
// ./src/ui/core/common/services/services.ts